/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Links {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { graphql } from "gatsby"
import { Section } from "@bw/bits"
import { Links as LinksModule } from "@bw/modules"

const Links = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  idAttribute,
  classAttribute,
  backgroundVariant,
  isFollowedByModuleWithBackgroundVariant,
  items,
}) => {
  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition,
        idAttribute,
        classAttribute,
        backgroundVariant,
        isFollowedByModuleWithBackgroundVariant,
      }}
    >
      <LinksModule links={items} />
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ...LinksModuleFragment
 *
 * This is also what you will get in the props of your Links
 * resolver component.
 */
export const query = graphql`
  fragment LinksModuleFragment on LinksModule {
    items {
      isExternal
      openInModal
      linkText
      linkType {
        value
      }
      url
      entry {
        url
      }
      description
    }
  }
`

export { Links }
